import { Controller } from "@hotwired/stimulus"

// Shows only the upload fields matching the selected document type in the
// customer portal's upload-document modal, and points the form at the
// matching controller's create action.
export default class extends Controller {
  static targets = ["section", "select"]

  connect() {
    this.toggle()
  }

  toggle() {
    const type = this.selectTarget.value

    this.sectionTargets.forEach((section) => {
      const active = section.dataset.documentType === type
      section.hidden = !active

      if (active) {
        this.element.action = section.dataset.url
      }

      section.querySelectorAll("input, select, textarea").forEach((field) => {
        if (field.matches('input[type="file"]')) return

        field.disabled = !active
      })
    })
  }
}
